import React from 'react';
import { useSelector } from 'react-redux';

import { Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  note: '',
};

export const FormInput = ({
  data,
  onInputChange,
  isLoading,
}) => {
  const StateForm = useSelector((state) => state?.Form);

  const [{ note }, setState] = React.useState(initialState);

  React.useEffect(() => {
    const state = {
      note,
    };

    onInputChange(state);
  }, [note]);

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      note: data?.note,
    }));
  }, [data]);

  return isLoading ? (
    <div className="col-md-12 mb-3">
      <SkeletonsForm count={2} />
    </div>
  ) : (
    <>
      <div className="col-md-12 mb-3" id="information">
        <Form.Textbox
          label="Catatan"
          type="text"
          value={note}
          onChange={(e) =>
            setState((prevState) => ({
              ...prevState,
              note: e?.target?.value,
            }))
          }
          error={StateForm?.errors?.note}
        />
      </div>
    </>
  );
};
